import { get } from 'lodash'

const parseField = field => {
    if (field["$ref"]){
        return {
            title: field.title,
            type: "reference",
            reference: Number(field["$ref"].split("/")[2]),
            required: field.requerido,
        }
    }

    if (field.type === "string" && !!field.schema_id){
        return {
            title: field.title,
            type: "technicalData",
            choicesSchema: Number(field.schema_id),
            required: field.requerido,
        }
    }

    if (field.type === "string" && field.format === "date-time"){
        return {
            title: field.title,
            type: "date",
            required: field.requerido
        }
    }

    if (field.type === "number" && !!field.extensions && !!field.fileType){
        return {
            title: field.title,
            type: "document",
            extensions: field.extensions,
            fileType: field.fileType,
            required: field.requerido
        }
    }

    const { requerido, ...rest } = field
    return {
        required: requerido,
        ...rest
    }
}

export const schemaAsFieldArray = (schema, definitions=null) => {
    const fields = [];
    const certification = !!schema.properties["ESTADO_CERTIFICACION"]
        ? schema.properties["ESTADO_CERTIFICACION"]
        : null

    for (let i in schema.order){
        const fieldName = schema.order[i]
        if (schema.properties.hasOwnProperty(fieldName)) {
            if (fieldName === "ESTADO_CERTIFICACION") { continue }

            const field = parseField(schema.properties[fieldName])
            field.name = fieldName

            if(!definitions){
                definitions = schema.definitions
            }
            const defSchema = get(definitions, `[${field.reference}]`)
            if (defSchema && field.type === "reference") {
                field.fields = schemaAsFieldArray(defSchema, definitions)
            }

            field.certification = !!certification
            fields.push(field)
        }
    }

    return fields
}
